import { render } from "./CompBottomContent.vue?vue&type=template&id=77b4d9da&scoped=true"
import script from "./CompBottomContent.vue?vue&type=script&lang=js"
export * from "./CompBottomContent.vue?vue&type=script&lang=js"

import "./CompBottomContent.vue?vue&type=style&index=0&id=77b4d9da&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77b4d9da"]])

export default __exports__